import { render, staticRenderFns } from "./ReviewDrawingTakCard.vue?vue&type=template&id=db887b1a&scoped=true"
import script from "./ReviewDrawingTakCard.vue?vue&type=script&lang=js"
export * from "./ReviewDrawingTakCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewDrawingTakCard.vue?vue&type=style&index=0&id=db887b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db887b1a",
  null
  
)

export default component.exports